import {
  useClearRefinements,
  UseClearRefinementsProps,
} from "react-instantsearch"

import CloseIcon from "../../../../media/icons/close.svg"

export default function ClearFilters(props: UseClearRefinementsProps) {
  const { canRefine, refine } = useClearRefinements(props)

  return (
    <>
      {canRefine && (
        <button
          className="hover:underline underline-offset-4 text-14 flex gap-2 items-center"
          disabled={!canRefine}
          onClick={refine}
        >
          <CloseIcon color="black" className="size-20" />
          Clear filters
        </button>
      )}
    </>
  )
}
